import { createAppAsyncThunk } from "@/store/thunks/createAppAsyncThunk";

export const fetchParticipants = createAppAsyncThunk(
  "sixDetail/fetchParticipants",
  async(sixId: string, { extra }) => await extra.sixDetailService.fetchParticipants(sixId)
);
